import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import { css, Global } from '@emotion/core';
import { theme as corgixTheme } from '@veeva/corgix/theme';
import defaultFontFamily from './fonts/defaultFontFamily';
import colors from './theme/colors';
import sizes from './theme/sizes';

const veevaIDTheme = {
    ...corgixTheme,
    ...colors,
    ...sizes,
    fontFamily: defaultFontFamily,
    veevaIdErrorLabelBufferHeight: '3.333rem',
};

function VeevaIDThemeProvider({ children }) {
    return (
        <EmotionThemeProvider theme={veevaIDTheme}>
            <Global
                styles={({ black, fontFamily, rootFont: rootFontSize }) => {
                    return css`
                        html,
                        body {
                            font-size: ${rootFontSize};
                            font-family: ${fontFamily};
                            color: ${black};
                            padding: 0;
                            margin: 0;
                        }
                    `;
                }}
            />
            {children}
        </EmotionThemeProvider>
    );
}

VeevaIDThemeProvider.displayName = 'VeevaIDThemeProvider';

export default VeevaIDThemeProvider;
